import axios from "@/utils/request.js";  // 引入封装的axios

//封装登录接口
export const LoginApi = ({ username, password }) => {
	return axios({
		url: '/admin/user/login',
		method: 'post',
		data: {
			username,
			password
		},
	})
}

//获取用户列表
export const getUserList = ({ pageNum, pageSize }) => {
	return axios({
		url: '/admin/user/userlist',
		method: 'post',
		data: {
			pageNum,
			pageSize
		},
	})
}

//封装添加用户列表
export const addUserList = ({ username,password}) => {
	return axios({
		url: '/admin/user/adduser',
		method: 'post',
		data:{
			username,
			password
		},
	})
}

//封装搜索用户
export const selectUserList = ({id}) => {
	return axios({
		url: `/admin/user/getUser`,
		method: 'post',
		data:{
			id
		}
	})
}

//封装修改用户接口
export const editUserList = ({username,password,id}) => {
	return axios({
		url: `/admin/user/updateuser/${id}`,
		method: 'put',
		data:{
			username,
			password,
		}
	})
}


//封装删除用户接口
export const delUserList = ({userid}) => {
	return axios({
		url: `/admin/user/userdelete`,
		method: 'post',
		data:{
			userid
		}
	})
}

//分类
export const Cateadd = ({catename,img}) => {
	return axios({
		url: `/admin/user/cateadd`,
		method: 'post',
		data:{
			catename,
			img
		}
	})
}
export const CateList = ({pageNum,pageSize}) => {
	return axios({
		url: `/admin/user/catelist`,
		method: 'post',
		data:{
			pageNum,
			pageSize
		}
	})
}


export const Catedel = ({id}) => {
	return axios({
		url: `/admin/user/catedel`,
		method: 'post',
		data:{
			id
		}
	})
}

//家教
export const Qicheadd = ({tel,img,desc,keywords,xueli,username,zhengshu,jingli,kemu,quyu,catename}) => {
	return axios({
		url: `/admin/user/Jjadd`,
		method: 'post',
		data:{
			tel,
			img,
			desc,
			keywords,
			xueli,
			username,
			zhengshu,
			jingli,
			kemu,
			quyu,
			catename
		}
	})
}

export const QicheList = ({pageNum,pageSize}) => {
	return axios({
		url: `/admin/user/Jjlist`,
		method: 'post',
		data:{
			pageNum,
			pageSize
		}
	})
}

export const Qichedel = ({id}) => {
	return axios({
		url: `/admin/user/Jjdel`,
		method: 'post',
		data:{
			id
		}
	})
}

//做家教
export const DingdanList = ({pageNum,pageSize}) => {
	return axios({
		url: `/admin/user/Qjjlist`,
		method: 'post',
		data:{
			pageNum,
			pageSize
		}
	})
}

export const Dingdandel = ({id}) => {
	return axios({
		url: `/admin/user/Qjjdel`,
		method: 'post',
		data:{
			id
		}
	})
}

//做家教
export const YoujiList = ({pageNum,pageSize}) => {
	return axios({
		url: `/admin/user/Zjjlist`,
		method: 'post',
		data:{
			pageNum,
			pageSize
		}
	})
}

export const Youjidel = ({id}) => {
	return axios({
		url: `/admin/user/Zjjdel`,
		method: 'post',
		data:{
			id
		}
	})
}

//系统
export const Xitongadd = ({title,content,time}) => {
	return axios({
		url: `/admin/user/Ggadd`,
		method: 'post',
		data:{
			title,content,time
		}
	})
}
export const XitongList = ({pageNum,pageSize}) => {
	return axios({
		url: `/admin/user/Gglist`,
		method: 'post',
		data:{
			pageNum,
			pageSize
		}
	})
}


export const Xitongdel = ({id}) => {
	return axios({
		url: `/admin/user/Ggdel`,
		method: 'post',
		data:{
			id
		}
	})
}


export const HomeUserlist = ({pageNum,pageSize}) => {
	return axios({
		url: `/admin/user/HomeUserlist`,
		method: 'post',
		data:{
			pageNum,pageSize
		}
	})
}

export const UpdataHomeUser = ({status,id}) => {
	return axios({
		url: `/admin/user/UpdataHomeUser/${id}`,
		method: 'put',
		data:{
			status
		}
	})
}


export const HomeUserdel = ({id}) => {
	return axios({
		url: `/admin/user/HomeUserdel`,
		method: 'post',
		data:{
			id
		}
	})
}